import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { navItems } from "./sidebar-data";
import { NavigationEnd, Router } from "@angular/router";
import { MediaMatcher } from "@angular/cdk/layout";
import { AppHorizontalNavItemComponent } from "./nav-item/nav-item.component";
import { CommonModule } from "@angular/common";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { NavItem } from "../../vertical/sidebar/nav-item/nav-item";
import { ApiService } from "../../../../../../../shared/src/lib/services/api.service";
import { environment } from "../../../../../../../shared/src/lib/environments/environment";
import { FeatureFlagService } from "../../../../../../../shared/src/lib/services/feature-flag.service";
import { WhiteLabelMarketConfig } from "../../../../pages/home/white-label/market-config/market-conifg.component";
import { of } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";
import { MaterialModule } from "../../../../material.module";

@Component({
  selector: "app-horizontal-sidebar",
  standalone: true,
  imports: [AppHorizontalNavItemComponent, CommonModule, MaterialModule],
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems = navItems;
  parentActive = "";
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  private isSuperAdmin: boolean = false;
  constructor(
    public navService: NavService,
    private apiService: ApiService,
    public router: Router,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private readonly featureFlagService: FeatureFlagService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 1100px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe((event) => {
      this.parentActive = this.router.url.split("/")[1];
      if (event instanceof NavigationEnd) {
        this.validItems();
      }
    });
  }

  ngOnInit(): void {
    this.validItems();
  }

  validItems() {
    let udata = this.apiService.getUserData();
    let role = udata.ROLE;
    let parentRole = udata.PARENT_ROLE;
    this.isSuperAdmin = role == "super_admin";
    let permissions = udata.PERMISSIONS.split(",");
    let items: NavItem[] = [];
    const shouldDisplayLivePnLFirst = environment.firstIndexPnl;
    const hasLivePnL = (name: string) => items.some((item) => item.displayName === name);
    let item = navItems.filter((item) => item.displayName == "Home");
    items = [...items, ...item];

    // if (this.featureFlagService.getFeature('enableDashboard')) {
    //   let item = navItems.filter(item => item.displayName == 'Dashboard')
    //   items = [...items, ...item]
    // }

    if (permissions.includes("sportsNavigationManagement") || this.isSuperAdmin) {
      let item = navItems.filter((item) => item.displayName == "Sports Navigation");
      items = [...items, ...item];
    }

    if (permissions.includes("canConfigureCasinoNavigation")) {
      let itemd = navItems.filter((item) => item.displayName == "Casino Navigation");
      items = [...items, ...itemd];
    }

    if (role !== "super_admin" && permissions.includes("canManagePermissions") && !!localStorage.getItem("userId")) {
      let item = navItems.filter((item) => item.displayName == "Permissions");
      items = [...items, ...item];
    }

    // if (permissions.includes('canSetCommission') && !this.featureFlagService.getFeature('enableStaticCommission')) {
    //   let item = navItems.filter(item => item.displayName == 'Commission')
    //   items = [...items, ...item]
    // }

    if (permissions.includes("canSetCommission") && !!localStorage.getItem("userId")) {
      let item = navItems.filter((item) => item.displayName === "Static Commission");
      items = [...items, ...item];
    }

    // if (permissions.includes('canSetTakeRisk') && !this.featureFlagService.getFeature('enableStaticRisk')) {
    //   let item = navItems.filter(item => item.displayName == 'Risk Taking');
    //   items = [...items, ...item];
    // }

    if (permissions.includes("canSetTakeRisk") && !!localStorage.getItem("userId")) {
      let item = navItems.filter((item) => item.displayName === "Static Risk");
      items = [...items, ...item];
    }

    if (permissions.includes("canConfigureCountry")) {
      let item = navItems.filter((item) => item.displayName == "Supported Countries");
      items = [...items, ...item];
    }
    if (permissions.includes("canConfigureCurrency")) {
      let item = navItems.filter((item) => item.displayName == "Exchange Rate");
      items = [...items, ...item];
    }
    if (permissions.includes("canConfigureSport")) {
      let item = navItems.filter((item) => item.displayName == "Supported Sports");
      items = [...items, ...item];
    }
    if (permissions.includes("canSetupBetFairAccounts")) {
      let item = navItems.filter((item) => item.displayName == "Betfair Accounts");
      items = [...items, ...item];
    }
    if (permissions.includes("canViewReports")) {
      let item = navItems.filter((item) => item.displayName == "Reports" || item.displayName == "Account Statement");
      items = [...items, ...item];
    }

    if (permissions.includes("canEnableWhiteLabel")) {
      let item = navItems.filter((item) => item.displayName == "White Labels");
      items = [...items, ...item];
    }
    if (permissions.includes("canEnableLiveStream")) {
      let item = navItems.filter((item) => item.displayName == "Live Stream");
      items = [...items, ...item];
    }
    if (permissions.includes("canEnableLiveScore")) {
      let item = navItems.filter((item) => item.displayName == "Live Score");
      items = [...items, ...item];
    }
    if (permissions.includes("canSendNotifications")) {
      let item = navItems.filter((item) => item.displayName == "Notificaions");
      items = [...items, ...item];
    }
    // if (shouldDisplayLivePnLFirst) {
    //   let livePnLItem = navItems.filter(item => item.displayName === 'Live PnL');
    //   if (livePnLItem.length > 0) {
    //     items = [...livePnLItem, ...items];
    //   }
    // }

    if (permissions.includes("canViewBettingPnL")) {
      let item = navItems.filter((item) => item.displayName === "Betting P/L");
      items = [...items, ...item];
    }

    if (permissions.includes("canViewPL")) {
      let item = navItems.filter((item) => item.displayName === "Live PnL");
      items = [...items, ...item];
    }

    if (permissions.includes("canViewBetInfo") && !!localStorage.getItem("userId")) {
      let item = navItems.filter((item) => item.displayName === "Bet Info");
      items = [...items, ...item];
    }

    if (permissions.includes("canViewAuditLogs")) {
      let item = navItems.filter((item) => item.displayName === "Audit Log");
      items = [...items, ...item];
    }

    if (permissions.includes("canHandleFunds")) {
      let item = navItems.filter(
        (item) =>
          item.navCap == "Funds" ||
          item.displayName == "Deposit" ||
          item.displayName == "Withdraw" ||
          item.displayName == "Transfer" ||
          item.displayName == "Wallets",
      );
      items = [...items, ...item];
    }

    if (permissions.includes("canManageRoles")) {
      let item = navItems.filter((item) => item.displayName === "Roles");
      items = [...items, ...item];
    }

    if (permissions.includes("canConfigureSystemConfigs")) {
      let item = navItems.filter((item) => item.displayName === "Services Config");
      items = [...items, ...item];
    }

    if (permissions.includes("canManageFeatureFlags")) {
      // if (this.featureFlagService.getFeature("enableFeatureFlag")) {
      let item = navItems.filter((item) => item.displayName == "Feature Flags");
      items = [...items, ...item];
      // }
    }

    if (permissions.includes("canDoResettlement")) {
      if (this.featureFlagService.getFeature("enableResettlement")) {
        let item = navItems.filter((item) => item.displayName == "Settlement");
        items = [...items, ...item];
      }
    }

    if (
      permissions.includes("canConfigureBookmakerFancy") &&
      permissions.includes("SB-BMAndFancy") &&
      (role == "admin" || (role == "operator" && parentRole == "admin"))
    ) {
      let item = navItems.filter((item) => item.displayName == "BM Fancy Nav Config");
      items = [...items, ...item];
    }
    if (permissions.includes("canCreateOperator")) {
      if (this.featureFlagService.getFeature("enableOperators")) {
        let item = navItems.filter((item) => item.displayName === "Operators");
        items = [...items, ...item];
      }
    }

    if (permissions.includes("setMaxMinBetSize") && (role == "admin" || (role == "operator" && parentRole == "admin"))) {
      let item = navItems.filter((item) => item.displayName == "Bet Config");
      items = [...items, ...item];
    }

    // if (permissions.includes("canEnableAutoBookmaker") && (role == "super_master" || role == "master" || role == "admin")) {
    //   let item = navItems.filter((item) => item.displayName == "0% Commission Market");
    //   items = [...items, ...item];
    // }

    if (this.isSuperAdmin || permissions.includes("canViewTransactions")) {
      let item = navItems.filter((item) => item.displayName === "Payments");
      items = [...items, ...item];
    }

    if (permissions.includes("canViewRegistrationReport") && (role === "admin" || role === "super_master")) {
      let item = navItems.filter((item) => item.displayName === "Registered Player Report");
      items = [...items, ...item];
    }

    if (this.isSuperAdmin || (permissions.includes("canViewClientReport") && (role === "admin" || role === "super_master" || role === "master"))) {
      let item = navItems.filter((item) => item.displayName === "Client PNL Report");
      items = [...items, ...item];
    }

    if (role === "master" && permissions.includes("canManagePaymentMethods")) {
      let item = navItems.filter((item) => item.displayName === "PSP Admin");
      items = [...items, ...item];
    }

    item = navItems.filter((item) => item.displayName == "Change Password");
    items = [...items, ...item];

    //set sidnav lists based on permissions
    this.navItems = items;

    let oUserData = this.apiService.getUserToken();
    const domainName = oUserData == null ? "" : oUserData.domain_name;
    if (domainName === "kjsports9.com") {
      const kjAdminItem = navItems.find((item) => item.displayName === "KJsport9 Admin");
      if (kjAdminItem) {
        items.push(kjAdminItem);
      }
    }

    if (permissions.includes("canViewBetTicker")) {
      this.loadTickerFromConfig("BET_TICKER", "Bet Ticker");
    }

    if (permissions.includes("betTickerHybrid")) {
      this.loadTickerFromConfig("BET_TICKER_HYBRID", "Bet Ticker V1");
    }

    if (permissions.includes("enableSupportChannels")) {
      let item = navItems.filter((item) => item.displayName === "Customer Support");
      this.navItems = [...this.navItems, ...item];
    }
  }
  private loadTickerFromConfig(configName: string, displayName: string) {
    const { DOMAIN_ID } = this.apiService.getUserData();

    const config$ =
      !DOMAIN_ID || DOMAIN_ID === "0"
        ? of<WhiteLabelMarketConfig[]>([])
        : this.apiService.send2ServerRelative(`white_label_market_config/${DOMAIN_ID}`, false).pipe(
            filter((res) => res.status === "ok"),
            map((res) => res.result),
          );

    config$
      .pipe(
        map((config) => {
          const isActive = (name: string): boolean => DOMAIN_ID === "0" || (config as any[]).some((c) => c.NAME === name && c.IS_ACTIVE);

          return isActive(configName) ? navItems.filter((i) => i.displayName === displayName) : [];
        }),
      )
      .subscribe((items) => {
        this.navItems = [...this.navItems, ...items];
      });
  }
}
